module.exports = __webpack_public_path__ + "static/mr-press-12-8fefb68c56701e70d65633a8ce611e48.jpg";